// Localhost
//const baseUrl = 'http://localhost:8080/v1';

// Staging
const baseUrl = 'https://atbcmqtt.aquasense.tech/v1';

// Production
// const baseUrl = 'https://atbc.aquasense.tech/v1';

export default baseUrl;
